<template>
  <div class="js-cart-login ws-vue-login-hijack">
    <a
      v-if="!loggedIn"
      v-cloak
      :href="loginUrlWithParam"
      class="account-menu__account account-menu__account--login"
      :class="{ hidden: initialPlacement }"
    >
      <img :src="loginIcon" alt="in" />
      {{ $t('login.hf_template.to_login') }}</a>
    <span
      v-else-if="cart.initial"
      class="account-menu__account account-menu__account--login"
    >
      <q-spinner class="q-mr-sm" />
    </span>
    <span v-else class="account-menu__account account-menu__account--logged">
      <a class="account-menu__logout-icon" :href="logoutUrl">
        <img :src="logoutIcon" alt="out" />
      </a>
      <span class="account-menu__account__name-wrapper">
        <span class="account-menu__account__name">
          {{ cart.user.login }}
        </span>
        <span class="account-menu__account__logout">
          {{ $t('login.hf_template.to_logout') }}
        </span>
      </span>
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { QSpinner } from 'quasar';

import type { Cart } from '@/types';
import { isBrowser } from '@loopia-group/utils';
import { getLoginUrl } from '@/utilities';
import config from '@/services/config.service';
import { logError } from '@/services/logger.service';
import loginIcon from '@/assets/images/loginIcon.svg';
import logoutIcon from '@/assets/images/logoutIcon.svg';
import {ROUTENAMES} from '@/consts/const.enum';

@Component({
  components: {
    QSpinner,
  },
  computed: {
    ...mapState(['cart']),
    ...mapGetters(['loggedIn']),
  },
})
export default class LoginLogout extends Vue {
  @Prop({ default: 0 })
  readonly index!: number;
  @Prop()
  readonly templateLoginEl!: HTMLElement;
  readonly cart!: Cart;
  readonly loggedIn!: boolean;
  initialPlacement = true;
  loginUrlWithParam = '';
  logoutUrl = '';

  data() {
    return {
      loginIcon,
      logoutIcon,
    };
  }

  created() {
    this.loginUrlWithParam = getLoginUrl(this.$router, ROUTENAMES.CART);
    this.logoutUrl = config.logoutUrl;
  }

  mounted() {
    this.hijack(this.templateLoginEl);
  }

  @Watch('templateLoginEl', { immediate: true })
  hijack(templateLoginEl: HTMLElement) {
    if (!isBrowser || !templateLoginEl || !this.$el) {
      return;
    }

    if (templateLoginEl.style.display === 'none') {
      // already hijacked, hot reload?
      return;
    }
    const parentNode = templateLoginEl.parentNode;

    if (!parentNode) {
      // something went wrong, did someone change HF template?
      logError(`parentNode missing. parentNode: ${parentNode}`);
      return;
    }
    parentNode.insertBefore(this.$el, templateLoginEl);

    templateLoginEl.style.display = 'none';
    this.initialPlacement = false;
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
</style>
